export default "__VITE_ASSET__2fa7479d__"